import { deleteProduct, getProduct, getProducts, patchProduct, postProduct } from '@/api/product.api';
import type { Product } from '@/domain/product/Product';
import type { IProductListResult, IProductRepository, TPatchProductDto, TPostProductDto } from '@/application/ports/IProductRepository';

// HTTP adapter for IProductRepository. Delegates to @/api/product.api, which
// owns the DTO ↔ domain mapping.
class HttpProductRepository implements IProductRepository {
    add(dto: TPostProductDto): Promise<Product> {
        return postProduct(dto);
    }

    get(name: string): Promise<Product> {
        return getProduct(name);
    }

    getAll(page?: number, limit?: number): Promise<IProductListResult> {
        return getProducts(page, limit);
    }

    remove(name: string): Promise<void> {
        return deleteProduct(name);
    }

    update(name: string, dto: TPatchProductDto): Promise<Product> {
        return patchProduct(name, dto);
    }
}

export { HttpProductRepository };
